import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProductAutomationDetailResponseDto } from "../../dtos/get-product-automation-detail-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductAutomationDetailQueryParams = {
  productId: string;
  options?: Omit<
    UseQueryOptions<GetProductAutomationDetailResponseDto>,
    "queryKey"
  >;
};

export const useGetProductAutomationDetailQuery = ({
  productId,
  options
}: UseGetProductAutomationDetailQueryParams) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductAutomationDetail({ productId })
      .queryKey,
    queryFn: async () =>
      await ProductService.getProductAutomationDetail({
        payload: { productId }
      }),
    ...options
  });
};
